import http from './http'

let showLoading = false


//总项目数量
export const getProCount = () => {
    return http({ method: 'get', url: `/heating/api/pro/count`, showLoading })
}
// 设备类型占比
export const getTypeCount = () => {
    return http({ method: 'get', url: '/heating/api/dev/type/count', showLoading })
}

// 设备数量
export const getDevCount = () => {
    return http({ method: 'get', url: '/heating/api/dev/count', showLoading })
}
// 告警设备数
export const getPoliceCountAlarm = () => {
    return http({ method: 'get', url: '/heating/api/police/countAlarm', showLoading })
}
// 未激活设备数
export const getPoliceCountUnactivated = () => {
    return http({ method: 'get', url: '/heating/api/police/countUnactivated', showLoading })
}
//在线统计
export const getProStatus = () => {
    return http({ method: 'get', url: `/heating/api/pro/status`, showLoading })
}


// 设备地域分布Top10 
export const getDevDis = () => {
    return http({ method: 'get', url: '/heating/api/pro/regional/dis' })
}
// 设备地图
export const getDevTop = () => {
    return http({ method: 'get', url: '/heating/api/dev/regional/top' })
}


